import { useQuery } from "@tanstack/react-query";
import { multipliersQueryOptions } from "@/api/multipliers";
import { Loader } from "@/components/general/common/loader";
import { transformToDefaultValues } from "@/components/general/Kpis/utils";
import { KpiMethodologyLayout } from "@/components/general/Kpis/KpiMethodologyLayout";

const LoadingState = () => (
    <div className="flex-1 flex items-center justify-center min-h-0 h-[640px] bg-surface-container-lowest rounded-xl shadow-sm p-6">
        <Loader message="Loading default KPI methodology data..." />
    </div>
);

const ErrorState = () => (
    <div className="flex-1 flex items-center justify-center min-h-0 h-[640px] bg-surface-container-lowest rounded-xl shadow-sm p-6">
        <p className="text-on-surface-variant">Failed to load default KPI methodology data</p>
    </div>
);

const KpisDefaultPage = () => {
    const { data: originalData, isLoading, error } = useQuery(multipliersQueryOptions());
    const defaultData = originalData ? transformToDefaultValues(originalData) : null;

    return (
        <>
            {isLoading && <LoadingState />}
            {error && <ErrorState />}
            {defaultData && (
                <div className="space-y-4">
                    <div
                        id="onboarding-kpis-current-info"
                        className="bg-surface-container-lowest rounded-xl shadow-sm px-6 py-4"
                        style={{ borderLeft: "4px solid #050066" }}
                    >
                        <p className="text-sm font-semibold text-primary mb-1">Default KPI Configuration</p>
                        <p className="text-sm text-on-surface-variant">
                            This view shows how the KPI system would look using only the default values as proposed by
                            Jit Team.
                        </p>
                    </div>
                    <div id="onboarding-kpis-methodology">
                        <KpiMethodologyLayout data={defaultData} isDefault />
                    </div>
                </div>
            )}
        </>
    );
};

export default KpisDefaultPage;
